import { LoadingGif } from '@insurgrid/ui';

export function Loading() {
  return (
    <div className="w-full h-full flex items-center justify-center my-auto">
      <LoadingGif />
    </div>
  );
}
